import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css';
import sharedCSS from '../shared.css';
import EmptyPart from './AlertList/Empty/index.js'

class Alert extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    if (!this.props.token) {
      this.props.goToRoot();
    }
  }

  componentWillReceiveProps(nexProps) {
    if (!nexProps.token) {
      this.props.goToRoot();
    }
  }

  render() {
    const {accountLevel, standard} = this.props.account;
    const isPremium = () => {
      if (parseInt(accountLevel) > parseInt(standard)) {
        return true;
      }
      return false;
    }

    return (
      <div className={cs(sharedCSS.widewrap)}>
        <div className={cs(css.headerWrapper)}>
          <h2>Load  Alerts</h2>
          <p>Add load alerts to receive notification of load updates.</p>
        </div>
        <div>
          {isPremium() ? this.props.children : <EmptyPart isPremium={true}/>}
        </div>
      </div>
    );
  }
}

export default connect(({user, account}) => ({
  token: user.token,
  account,
}), mapDispatch({
  goToRoot: () => changeURL('/'),
}))(Alert);



// WEBPACK FOOTER //
// ./src/components/Alert/index.js